import styled from 'styled-components';

const HeaderContainer = styled.div`
  ${({ stickyHeader, bannerData }) => {
    if (stickyHeader) {
      return `
        position: ${bannerData.height > 0 && !bannerData.scrolled ? 'absolute' : 'fixed'};
        top: ${bannerData.height > 0 && bannerData.scrolled ? `${bannerData.height}px` : '0'};
        width: 100%;
        z-index: 999;
        transition: all 0.7s;
      `;
    }
  }}

  ${({ displaySimpleHeader, simpleHeader }) => {
    if (displaySimpleHeader && simpleHeader) {
      return `
        .website-header {
          display: none;
        }
      `;
    }
  }}
`;

export { HeaderContainer };

export const HorizontalProgressBar = styled.div`
  display: flex;

  & > div:first-child {
    z-index: 999;
    position: static !important;
    left: 0;
    width: 10%;
    height: 4px;
    bottom: -4px;
    background-color: var(--secondary-color);
    overflow: hidden;
  }

  & > div:nth-child(2) {
    top: unset !important;
    position: static !important;
  }
`;
